export enum SortType {
    desc,asc
}

export class SortCondition {
    sortFirst: string;
    sortSecond: string;
    sortFirstAsc: SortType;
    sortSecondAsc: SortType;

    constructor() {
        this.sortFirst = "";
        this.sortSecond = "";
        this.sortFirstAsc = SortType.desc;
        this.sortSecondAsc = SortType.desc;
    }
}